import React from "react";
import {DataTable, Modal, P} from "@tag/tag-components-react-v4";
import {OrganisationDTO} from "../../types/OrganisationDTO";
import { ProjectAccents } from "../../../General/config/projectAccents";

function DataEngineDetails(props: { visible: boolean, selectedOrganisation: OrganisationDTO, handleClose: Function }) {
    
    const columns = React.useMemo(
        () => [
            { accessorKey: 'key', header: 'Key' },
            { accessorKey: 'value', header: 'Value'}
        ],
        [],
    );
    
    const data = props.selectedOrganisation.dataEngineApiGuid ? [
        {
            key: 'API',
            value: props.selectedOrganisation.dataEngineApiGuid
        }
    ] : [];
    
    const renderModalContent = () => {
        return (
            <>
                <DataTable
                    columns={columns}
                    data={data}
                    noDataElement={<P>Sorry, there is no Data Engine Data available.</P>}
                />
            </>
        )
    }
    
    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PoliciesAndProcedures}
            heading={`Data Engine Details`}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default DataEngineDetails;
